import { DocumentStatus } from '../../../../../api/enumerations';
import { ContractStatus } from '../../../../../api/theHive/notices/enumerations';
import { SignedContractData } from '../../../../../api/theHive/notices/types';
import {
  IconBlockMS,
  IconCancelMS,
  IconCheckCircleMS,
  IconEditDocumentMS,
  IconFactCheckMS,
  IconScheduleMS,
} from '../../../../../constants/icons';

interface DocumentStatusStyle {
  color: string;
  background: string;
  icon: JSX.Element;
}

const documentStatusStyles: Record<DocumentStatus, DocumentStatusStyle> = {
  [DocumentStatus.PENDING]: {
    color: '#5C5F66',
    background: '#F1F1F3',
    icon: IconScheduleMS,
  },
  [DocumentStatus.UNDER_ANALYSIS]: {
    color: '#1D5FD1',
    background: '#E8F1FE',
    icon: IconFactCheckMS,
  },
  [DocumentStatus.APPROVED]: {
    color: '#1E8A4C',
    background: '#E7F7EE',
    icon: IconCheckCircleMS,
  },
  [DocumentStatus.APPROVED_WITH_RESERVATIONS]: {
    color: '#0B7A5A',
    background: '#E0F2EC',
    icon: IconCheckCircleMS,
  },
  [DocumentStatus.REJECTED]: {
    color: '#FF4C4C',
    background: '#FFEAEA',
    icon: IconCancelMS,
  },
  [DocumentStatus.CANCELED]: {
    color: '#44464C',
    background: '#EDEEF0',
    icon: IconBlockMS,
  },
  [DocumentStatus.REPLACEMENT_REQUEST]: {
    color: '#B25E09',
    background: '#FFF4E5',
    icon: IconEditDocumentMS,
  },
};

export const getDocumentStatusStyle = (
  status: DocumentStatus
): DocumentStatusStyle =>
  documentStatusStyles[status] ?? documentStatusStyles[DocumentStatus.PENDING];

// Contract already sent by the provider and not yet reviewed by the panel.
export const isContractPendingReview = (
  contract: SignedContractData | null | undefined
): boolean =>
  !!contract?.uploaded_at &&
  contract.status !== ContractStatus.APPROVED &&
  contract.status !== ContractStatus.REJECTED;

// Preview em texto puro do motivo de rejeição (que agora é rich text/HTML):
// remove as tags para a prévia na célula da tabela. O texto completo formatado
// é exibido no diálogo (RichTextViewer).
export const stripHtml = (html: string | null | undefined): string =>
  (html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
